import { Component, OnInit } from '@angular/core';
import { REQUEST_STEPS } from '../enum-request-steps';
import {
  MarketPlaceQuoteRequestService,
  CAR_TYPE,
} from 'src/app/services/market-place-quote-request-service/market-place-quote-request.service';
import { draftQuoteRequest } from 'src/app/services/market-place-quote-request-service/draft-quote-request.service';
@Component({
  selector: 'app-mechanical-options',
  templateUrl: './mechanical-options.component.html',
  styleUrls: ['./mechanical-options.component.scss'],
})
export class MechanicalOptionsComponent implements OnInit {
  quoteRequest: any;
  objMechanicalOptions: any;
  selectedCarType: any;
  enum_car_type = CAR_TYPE;

  constructor(
    private quoteRequestService: MarketPlaceQuoteRequestService,
    private draftQuoteService: draftQuoteRequest
  ) {
    this.quoteRequestService.quoteRequest$.subscribe((value) => {
      this.selectedCarType = this.quoteRequestService.getSelectedCarType();
      // TODO => fill form with this.objMechanicalOptions[this.selectedCarType];
    });
  }

  ngOnInit(): void {}

  next() {
    // TODO => you should submit the values by calling setQuoteRequest in the below line
    //this.quoteRequest['mechanical-options'][this.selectedCarType] = current mechanical options form values
    //this.quoteRequestService.setQuoteRequest(this.quoteRequest);
    this.quoteRequestService.setNextStep(REQUEST_STEPS.LEASING_OPTIONS);
    window.scrollTo(0, 0);
    this.draftQuoteService.saveDraftQuation(REQUEST_STEPS.LEASING_OPTIONS);
  }

  back() {
    // TODO => you should submit the values by calling setQuoteRequest in the below line
    //this.quoteRequest['mechanical-options'][this.selectedCarType] = current mechanical options form values
    //this.quoteRequestService.setQuoteRequest(this.quoteRequest);
    this.quoteRequestService.setNextStep(REQUEST_STEPS.SELECTION);
    window.scrollTo(0, 0);
  }
}
